import React, { FunctionComponent } from "react";
import { Table, Tooltip, Grid, Fab, MuiThemeProvider } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { useConfigStyles } from "../../configStyles";
import { posConfigType } from "../posConfigType";
import MUIDataTable from "mui-datatables";
import { useTableStyles } from "../../../useTableStyle";
import { getDecryptedData } from "../../../../utils/crypto";
import { ThemeProvider } from "@mui/material/styles";

const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const columns = [
  "Name",
  "Config Value",
  "Label Naming",
  "Display Order",
  "Is Sync",
  "",
];

const options = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

interface PosConfigTableProps {
  posConfigurations: Array<posConfigType> | any;
  goToEdit: (id: number) => void;
  editPosConfigPermission: boolean;
}
export const PosConfigurationTableList: FunctionComponent<PosConfigTableProps> = ({
  posConfigurations,
  goToEdit,
  editPosConfigPermission,
}) => {
  const classes = useConfigStyles();
  const getMuiTheme = useTableStyles();

  if (posConfigurations && posConfigurations.length > 0) {
    return (
      <Table>
        <ThemeProvider theme={getMuiTheme}>
          <MUIDataTable
            title={"Pos Configuration List"}
            data={posConfigurations.map((posConfig: any) => {
              return [
                posConfig.name,
                posConfig.name.slice(-3).toLowerCase() === "pwd"
                  ? getDecryptedData(posConfig.config_value).replace(/./g, "*")
                  : posConfig.config_value,
                posConfig.lbl_naming !== null ? posConfig.lbl_naming : "-",
                posConfig.display_order !== null
                  ? posConfig.display_order
                  : "-",
                posConfig.is_sync ? "Yes" : "No",
                <Grid container direction="row" spacing={2}>
                  <Grid
                    item
                    style={{ display: editPosConfigPermission ? "" : "none" }}
                  >
                    <Tooltip title={"Edit"}>
                      <Fab
                        size="small"
                        aria-label="edit"
                        color="primary"
                        className={classes.editIconMargin}
                        onClick={() => goToEdit(posConfig.config_id)}
                      >
                        <EditIcon className={classes.editIcon} />
                      </Fab>
                    </Tooltip>
                  </Grid>
                </Grid>,
              ];
            })}
            columns={columns}
            options={options}
          />
        </ThemeProvider>
      </Table>
    );
  } else {
    return (
      <div className={classes.root}>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Pos Configuration List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  }
};
